import { c as _c } from "react/compiler-runtime";
import { useQueries } from "@tanstack/react-query";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseUserWinningArtworksProps {
  readonly user: ApiProfileMin;
  readonly enabled?: boolean;
}
const fetchDrop = async (dropId: string): Promise<ApiDrop> => {
  return commonApiFetch<ApiDrop>({
    endpoint: `drops/${dropId}`
  });
};
export const useUserWinningArtworks = t0 => {
  const $ = _c(21);
  const {
    user,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== user.winner_main_stage_drop_ids) {
    t2 = user.winner_main_stage_drop_ids || [];
    $[0] = user.winner_main_stage_drop_ids;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const winnerDropIds = t2;
  let t3;
  if ($[2] !== enabled || $[3] !== winnerDropIds) {
    let t4;
    if ($[5] !== enabled || $[6] !== winnerDropIds.length) {
      t4 = dropId => ({
        queryKey: [QueryKey.DROP, {
          drop_id: dropId
        }],
        queryFn: () => fetchDrop(dropId),
        enabled: enabled && winnerDropIds.length > 0,
        staleTime: 300000
      });
      $[5] = enabled;
      $[6] = winnerDropIds.length;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = winnerDropIds.map(t4);
    $[2] = enabled;
    $[3] = winnerDropIds;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      queries: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const queries = useQueries(t4);
  let t5;
  if ($[10] !== queries) {
    t5 = queries.some(_temp);
    $[10] = queries;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const isLoading = t5;
  let t6;
  if ($[12] !== queries) {
    t6 = queries.some(_temp2);
    $[12] = queries;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const isError = t6;
  let t7;
  if ($[14] !== queries) {
    t7 = queries.filter(_temp3).map(_temp4);
    $[14] = queries;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const winningDrops = t7;
  let t8;
  if ($[16] !== isError || $[17] !== isLoading || $[18] !== winnerDropIds || $[19] !== winningDrops) {
    t8 = {
      winningDrops,
      isLoading,
      isError,
      winnerDropIds
    };
    $[16] = isError;
    $[17] = isLoading;
    $[18] = winnerDropIds;
    $[19] = winningDrops;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp(query) {
  return query.isLoading;
}
function _temp2(query_0) {
  return query_0.isError;
}
function _temp3(query_1) {
  return query_1.data;
}
function _temp4(query_2) {
  return query_2.data as ApiDrop;
}